var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5537 15.7643C11.0931 15.7643 11.5303 15.3271 11.5303 14.7878C11.5303 14.2484 11.0931 13.8112 10.5537 13.8112C10.0144 13.8112 9.57715 14.2484 9.57715 14.7878C9.57715 15.3271 10.0144 15.7643 10.5537 15.7643Z",
    fill: "#677C95"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5537 0.00488281C5.02699 0.00488281 0.553711 4.47742 0.553711 10.0049C0.553711 15.5316 5.02625 20.0049 10.5537 20.0049C16.0804 20.0049 20.5537 15.5323 20.5537 10.0049C20.5537 4.47816 16.0812 0.00488281 10.5537 0.00488281ZM10.5537 18.4424C5.89055 18.4424 2.11621 14.6687 2.11621 10.0049C2.11621 5.34172 5.88992 1.56738 10.5537 1.56738C15.2169 1.56738 18.9912 5.34109 18.9912 10.0049C18.9912 14.668 15.2175 18.4424 10.5537 18.4424Z",
    fill: "#677C95"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5537 5.02367C8.83059 5.02367 7.42871 6.42554 7.42871 8.14867C7.42871 8.58015 7.77848 8.92992 8.20996 8.92992C8.64145 8.92992 8.99121 8.58015 8.99121 8.14867C8.99121 7.2871 9.69215 6.58617 10.5537 6.58617C11.4153 6.58617 12.1162 7.2871 12.1162 8.14867C12.1162 9.01023 11.4153 9.71117 10.5537 9.71117C10.1222 9.71117 9.77246 10.0609 9.77246 10.4924V12.4455C9.77246 12.877 10.1222 13.2268 10.5537 13.2268C10.9852 13.2268 11.335 12.877 11.335 12.4455V11.1748C12.6813 10.827 13.6787 9.60214 13.6787 8.14867C13.6787 6.42554 12.2768 5.02367 10.5537 5.02367Z",
    fill: "#677C95"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.c3545d86d578ce451b6f0e9e9bef191a.svg";
export { ForwardRef as ReactComponent };